import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_home",
  "use": "icon_home-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon_home\"><path d=\"M25.471 13.25a.75.75 0 00-.174-.196L14.772 2.659a1.103 1.103 0 00-1.566 0L2.66 13.054c-.218.217-.327.5-.327.805v10.83c0 .608.5 1.13 1.131 1.13h7.263v-9.481h6.524v9.48h7.285c.609 0 1.13-.5 1.13-1.13v-10.83a1.436 1.436 0 00-.195-.608z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol